//
//
//
//
//
//
//
//
//
export default {
  name: "TextScroll",
  props: {
    dataList: {
      type: Array,
      default: []
    },
    scrollType: {
      type: String,
      default: "scroll-up"
    }
  },
  data: function data() {
    return {
      count: 0,
      // 当前索引
      intervalId: null,
      // 定时器ID
      playTime: 1000 // 定时器执行间隔

    };
  },
  methods: {
    getText: function getText() {
      var len = this.dataList.length; // 获取数组长度

      if (len === 0) {
        return; // 当数组为空时，直接返回
      }

      if (this.count === len - 1) {
        // 当前为最后一个时
        this.count = 0; // 从第一个开始
      } else {
        this.count++; // 自增
      }
    },
    init: function init() {
      var _this = this;

      // 根据不同的动画效果，指定不同的动画时间，可配合底部的css样式修改
      switch (this.scrollType) {
        case "scroll-up":
          {
            this.playTime = 3000;
            break;
          }

        case "scroll-up-linear":
          {
            this.playTime = 1000;
            break;
          }

        case "scroll-left":
          {
            this.playTime = 2000;
            break;
          }

        case "scroll-left-linear":
          {
            this.playTime = 4000;
            break;
          }

        default:
          {
            this.playTime = 2000;
            break;
          }
      }

      if (this.intervalId !== null) {
        clearInterval(this.intervalId);
      }

      this.count = 0;
      this.intervalId = setInterval(function () {
        // 定义定时器
        _this.getText();
      }, this.playTime);
    }
  },
  created: function created() {
    this.init();
  },
  activated: function activated() {
    this.init();
  },
  destroyed: function destroyed() {
    console.log("TextScroll button beforeDestroy");
    clearInterval(this.intervalId); // 清除定时器
  },
  deactivated: function deactivated() {
    console.log("TextScroll button deactivated");
    clearInterval(this.intervalId); // 清除定时器
  }
};